import React from 'react';

import TopBar from '../TopBar'
import Footer from '../Footer'
import Body from '../Body'

const Main = ({ children, toggled, isCollapsed }) => {
    return ( 
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content"> 
                <TopBar toggled={toggled} isCollapsed={isCollapsed} />

                <Body children={children} />
            </div>

            <Footer />
      </div>
     );
}
 
export default Main;